var map = {
	"./api.svg": 897,
	"./css.svg": 772,
	"./express.svg": 785,
	"./git.svg": 21,
	"./github.svg": 394,
	"./heroku.svg": 991,
	"./html.svg": 132,
	"./javascript.svg": 602,
	"./jira.svg": 495,
	"./linkedin.svg": 49,
	"./mail.svg": 814,
	"./mongodb.svg": 255,
	"./netlify.svg": 942,
	"./nodejs.svg": 338,
	"./react.svg": 32,
	"./typescript.svg": 330,
	"./vscode.svg": 141
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 615;